var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// A recursive helper function for walking through all nodes
export function visitTreeNodes(parent, visitFn, childrenFn) {
    var e_1, _a;
    if (!parent) {
        return;
    }
    visitFn(parent);
    try {
        for (var _b = __values(childrenFn(parent)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            visitTreeNodes(child, visitFn, childrenFn);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
// Returns all children of a node, including collapsed children
export function allChildren(n) {
    var _a, _b;
    return ((_a = n.children) !== null && _a !== void 0 ? _a : []).concat((_b = n.collapsedChildren) !== null && _b !== void 0 ? _b : []);
}
